import React from 'react'
import { cn } from '../../utils'

/**
 * Grid Component
 * Responsive grid layout with adaptive columns
 */
export const Grid = ({ 
  children, 
  cols = 1, 
  gap = 4, 
  adaptive = false,
  className,
  ...props 
}) => {
  const gridClasses = cn(
    'grid',
    `grid-cols-${cols}`,
    `gap-${gap}`,
    adaptive && 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    className
  )

  return (
    <div className={gridClasses} {...props}>
      {children}
    </div>
  )
}

export default Grid